import {
  setQueryStringValue,
  getIntValueFromQueryString,
  deleteQueryString,
} from './queryString';

import {
  paramsDefaults,
  skipParamName,
  takeParamName,
  geoTypeIdParamName,
  groupIdParamName,
  geoIdParamName,
  atiDocsParamName,
  autoparkParamName,
  atiOrdersParamName,
  verifiedParamName,
  confirmedContactsParamName,
  epdMedalParamName,
} from '../constants/uiParams';

export const getSkipQsValue = () => getIntValueFromQueryString(skipParamName, paramsDefaults.Skip);
export const getTakeQsValue = () => getIntValueFromQueryString(takeParamName, paramsDefaults.Take);

export const setSkipQsValue = value => setQueryStringValue(skipParamName, value);
export const setTakeQsValue = value => setQueryStringValue(takeParamName, value);

const getIntValueFromQsMethods = paramName => (
  {
    value: getIntValueFromQueryString(paramName),
    clear: () => deleteQueryString(paramName),
  }
);

export const getGeoTypeIdFromQsMethods = () => getIntValueFromQsMethods(geoTypeIdParamName);
export const getGeoIdFromQsMethods = () => getIntValueFromQsMethods(geoIdParamName);
export const getGroupIdFromQsMethods = () => getIntValueFromQsMethods(groupIdParamName);
export const getAtiDocsFromQsMethods = () => getIntValueFromQsMethods(atiDocsParamName);
export const getAutoparkFromQsMethods = () => getIntValueFromQsMethods(autoparkParamName);
export const getAtiOrdersFromQsMethods = () => getIntValueFromQsMethods(atiOrdersParamName);
export const getVerifiedFromQsMethods = () => getIntValueFromQsMethods(verifiedParamName);
export const getConfirmedContactsFromQsMethods = () => getIntValueFromQsMethods(confirmedContactsParamName);
export const getEpdMedalFromQsMethods = () => getIntValueFromQsMethods(epdMedalParamName);
